/**
 * Error codes for role-related operations (mirrors backend)
 */
export enum RoleErrorCode {
    ROLE_NOT_FOUND = 'ROLE_NOT_FOUND',
    ROLE_ALREADY_EXISTS = 'ROLE_ALREADY_EXISTS',
    INVALID_PERMISSIONS = 'INVALID_PERMISSIONS',
    CANNOT_DELETE_SYSTEM_ROLE = 'CANNOT_DELETE_SYSTEM_ROLE',
    ROLE_NOT_IN_INVESTIGATION = 'ROLE_NOT_IN_INVESTIGATION',
    CANNOT_DELETE_ASSIGNED_ROLE = 'CANNOT_DELETE_ASSIGNED_ROLE',
    INVESTIGATION_NOT_FOUND = 'INVESTIGATION_NOT_FOUND',
    UNAUTHORIZED = 'UNAUTHORIZED'
}

export const roleErrorCodeToTranslationKey: Record<RoleErrorCode, string> = {
    [RoleErrorCode.ROLE_NOT_FOUND]: 'investigation.share.custom_roles.error_role_not_found',
    [RoleErrorCode.ROLE_ALREADY_EXISTS]: 'investigation.share.custom_roles.error_role_already_exists',
    [RoleErrorCode.INVALID_PERMISSIONS]: 'investigation.share.custom_roles.error_invalid_permissions',
    [RoleErrorCode.CANNOT_DELETE_SYSTEM_ROLE]: 'investigation.share.custom_roles.error_cannot_delete_system_role',
    [RoleErrorCode.ROLE_NOT_IN_INVESTIGATION]: 'investigation.share.custom_roles.error_role_not_in_investigation',
    [RoleErrorCode.CANNOT_DELETE_ASSIGNED_ROLE]: 'investigation.share.custom_roles.error_delete_assigned',
    [RoleErrorCode.INVESTIGATION_NOT_FOUND]: 'investigation.share.custom_roles.error_investigation_not_found',
    [RoleErrorCode.UNAUTHORIZED]: 'investigation.share.error.unauthorized'
};
